import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M951.619765,688.015059 C943.262118,685.869176 934.226824,684.852706 924.739765,684.852706 C860.928,684.852706 776.222118,734.208 723.930353,830.885647 C660.005647,949.248 656.843294,1099.008 716.928,1158.07624 C780.175059,1220.30682 905.991529,1164.288 975.224471,1125.32329 C1004.58918,1108.94682 1030.79153,1091.89271 1054.62212,1074.61271 C1046.82918,1025.70918 1043.55388,968.222118 1044.68329,901.925647 C1046.94212,782.095059 1012.94682,704.278588 951.619765,688.015059 M1169.12188,1271.90965 C1135.23953,1256.32376 1108.47247,1228.65318 1088.48188,1188.55906 C1070.29835,1200.41788 1051.09835,1212.27671 1030.54306,1223.68376 C932.171294,1278.912 854.354824,1299.24175 792.801882,1299.24175 C720.180706,1299.35435 670.599529,1271.00612 637.733647,1238.592 C530.552471,1133.10494 546.816,921.227294 624.632471,777.227294 C704.707765,629.161412 854.241882,545.697882 980.284235,578.789647 C1035.06071,593.246118 1162.11953,653.669647 1157.60188,903.834353 C1157.15012,932.747294 1157.48894,958.610824 1158.61835,981.537882 C1273.25365,852.897882 1275.06071,733.744941 1275.06071,726.968471 L1388.00188,725.613176 C1388.11482,735.664941 1388.34071,935.344941 1180.98071,1118.08376 C1195.09835,1156.59671 1211.02306,1166.87435 1216.33129,1169.35906 C1237.33835,1178.95906 1276.98071,1161.45318 1317.75247,1125.19906 L1392.74541,1209.67906 C1313.68659,1279.92847 1234.40188,1302.06494 1169.12188,1271.90965 M959.954824,-0.0338823529 C430.599529,-0.0338823529 -0.0451764706,430.723765 -0.0451764706,959.966118 C-0.0451764706,1489.32141 430.599529,1919.96612 959.954824,1919.96612 C1489.42306,1919.96612 1919.95482,1489.32141 1919.95482,959.966118 C1919.95482,430.723765 1489.42306,-0.0338823529 959.954824,-0.0338823529",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconQuizStatsCronbachsAlphaSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconQuizStatsCronbachsAlphaSolid, _Component);

  var _super = _createSuper(IconQuizStatsCronbachsAlphaSolid);

  function IconQuizStatsCronbachsAlphaSolid() {
    _classCallCheck(this, IconQuizStatsCronbachsAlphaSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconQuizStatsCronbachsAlphaSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconQuizStatsCronbachsAlpha",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconQuizStatsCronbachsAlphaSolid.displayName = "IconQuizStatsCronbachsAlphaSolid";
  return IconQuizStatsCronbachsAlphaSolid;
}(Component);

IconQuizStatsCronbachsAlphaSolid.glyphName = 'quiz-stats-cronbachs-alpha';
IconQuizStatsCronbachsAlphaSolid.variant = 'Solid';
IconQuizStatsCronbachsAlphaSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconQuizStatsCronbachsAlphaSolid;
export { IconQuizStatsCronbachsAlphaSolid };